export default [
    {
        path: "/reschedule-requests",
        name: "reschedule-requests",
        component: () => import("./RescheduleRequestsPage.vue"),
        meta: {
            layout: "DefaultLayout"
        }
    }
];
